
define('template!ordersSampleView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="status sample" title="Sample">\n  <i class="mdi-image-filter-1"></i>\n</div>\n';

}
return __p
};});

